import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    AutomobilesEmails,
    CreateAutomobilesEmailsInput,
    UpdateAutomobileInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class AutomobileEmailsService {
    private amplifyClient = generateClient();
    constructor() {}

    async listAutomobilesEmails(): Promise<AutomobilesEmails[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listAutomobilesEmails
                })
            ).data.listAutomobilesEmails.items;
            if (data) return data as AutomobilesEmails[];
        } catch (error) {
            console.error('Error finding automobileSEmails:', error);
            return null;
        }
    }

    async automobilesEmailsByCompanyId(
        companyId: string
    ): Promise<AutomobilesEmails[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.AutomobilesEmailsByCompanyId,
                    variables: {
                        companyId
                    }
                })
            ).data.AutomobilesEmailsByCompanyId.items;
            if (data) return data as AutomobilesEmails[];
        } catch (error) {
            console.error('Error finding automobileSEmails:', error);
            return null;
        }
    }

    async createAutomobilesEmails(
        input: CreateAutomobilesEmailsInput
    ): Promise<AutomobilesEmails> {
        try {
            const automobile = (
                await this.amplifyClient.graphql({
                    query: mutations.createAutomobilesEmails,
                    variables: {
                        input
                    }
                })
            ).data.createAutomobilesEmails;
            if (automobile) return automobile as AutomobilesEmails;
        } catch (error) {
            console.error('Error creating automobile:', error);
            return null;
        }
    }

    async updateAutomobilesEmails(
        input: UpdateAutomobileInput
    ): Promise<AutomobilesEmails> {
        try {
            const automobile = (
                await this.amplifyClient.graphql({
                    query: mutations.updateAutomobilesEmails,
                    variables: {
                        input
                    }
                })
            ).data.updateAutomobilesEmails;
            if (automobile) return automobile as AutomobilesEmails;
        } catch (error) {
            console.error('Error updating automobile', error);
            return null;
        }
    }
}
